import { offerService } from '../services'

const state = {
    tiers: {
        loading: false,
        rows: []
    },
    offers: {
        loading: false,
        rows: []
    },
}

const actions = {

    getTiers ({ dispatch, commit }) {
        commit('getTiersRequest')
        return offerService.getTiers().then(
            response => {
                commit('getTiersSuccess', response)
            },
            error => {
                commit('getTiersError')
                dispatch('alert/error', 'Unable to load tiers: ' + error, { root: true })
            }
        )
    },
    getAll ({ dispatch, commit }, params) {
        commit('getOffersRequest')
        return offerService.getAll(params).then(
            response => {
                dispatch('getTiers')
                commit('getOffersSuccess', response)
            },
            error => {
                commit('getOffersError')
                dispatch('alert/error', 'Unable to load offers: ' + error, { root: true })
            }
        )
    },
    getTemplateOffers ({ dispatch, commit }, template_id) {
        commit('getOffersRequest')
        return offerService.getTemplateOffers(template_id).then(
            response => {
                commit('getOffersSuccess', response)
            },
            error => {
                commit('getOffersError')
                dispatch('alert/error', 'Unable to load offers: ' + error, { root: true })
            }
        )
    },

}

const mutations = {
    getTiersRequest (state) {
        state.tiers = { loading: true, rows: [] }
    },
    getTiersSuccess (state, data) {
        state.tiers = { loading: false, rows: data.rows }
    },
    getTiersError (state) {
        state.tiers = { loading: false, rows: [] }
    },
    getOffersRequest (state) {
        state.offers = { loading: true, rows: [] }
    },
    getOffersSuccess (state, data) {
        state.offers = { loading: false, rows: data.rows }
    },
    getOffersError (state) {
        state.offers = { loading: false, rows: [] }
    },
}

const getters = {
    isBusy(state) {
        return state.offers.loading === true
    },
    getTiers (state) {
        return state.tiers.rows
    },
    getOffers (state) {
        return state.offers.rows
    },
    getOffersForSelect(state, getters) {
        let availableOffers = [
            {value: null, text: 'No Offer'},
            {value: 'new', text: 'Create New Offer'},
        ]

        // if tiers here, we can extend this list of create actions
        for (const [idx, tier] of Object.entries(getters.getTiers)) {
            if (tier.type === 'paid') {
                availableOffers.push(
                    {value: 'new_base_' + tier.id + '-monthly', text: 'Full Price - ' + tier.name + ' Monthly'},
                    {value: 'new_base_' + tier.id + '-yearly', text: 'Full Price - ' + tier.name + ' Annual'},
                );
            }
        }

        if (getters.getOffers && getters.getOffers.length) {
            availableOffers.push({value: null, text: '—————————————————————', disabled: true});
        }

        for (const [idx, offer] of Object.entries(getters.getOffers)) {
            let description = offer.name + ' - ';
            if (offer.cadence === 'month') {
                description += 'Monthly ('
            } else {
                description += "Yearly ("
            }
            if (offer.type === 'percent') {
                description += offer.amount + '%'
            } else {
                description += offer.amount/100 + ' ' + offer.currency
            }
            description += " OFF)";

            availableOffers.push(
                {value: offer.id, text: description},
            );
        }
        return availableOffers;
    },
    getBlogTiers(state) {
        let tiers = [];
        for (const [idx, tier] of Object.entries(state.tiers.rows)) {
            if (tier.yearly_price) {
                const currency = tier.currency.toUpperCase();
                tiers.push({id: tier.id, value: tier.id + '-yearly', cadence: 'year', text: tier.name + ' - Annual (' + tier.yearly_price / 100 + ' ' + currency + ')', currency: currency, amount: tier.yearly_price / 100, cadenceLabel: 'Annual', name: tier.name})
            }
            if (tier.monthly_price) {
                const currency = tier.currency.toUpperCase();
                tiers.push({id: tier.id, value: tier.id + '-monthly', cadence: 'month', text: tier.name + ' - Monthly (' + tier.monthly_price / 100 + ' ' + currency + ')', currency: currency, amount: tier.monthly_price / 100, cadenceLabel: 'Monthly', name: tier.name})
            }
        }
        return tiers;
    },
    getBlogPaidTiersOptions(state) {
        let tiers = [];
        for (const [idx, tier] of Object.entries(state.tiers.rows)) {
            if (tier.type === 'paid') {
                tiers.push({value: tier.id, text: tier.name})
            }
        }
        return tiers;
    },
}

export const offerModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
